/**
 * Pickup Availability (New) - Independent JavaScript for Buy Buttons (New)
 * This is a complete copy of the original pickup-availability.js with a new custom element name
 * to ensure complete independence from the original buy buttons.
 */

if (!customElements.get("pickup-availability-new")) {
  customElements.define(
    "pickup-availability-new",
    class PickupAvailabilityNew extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute("available")) return;

        this.errorHtml =
          this.querySelector("template").content.firstElementChild.cloneNode(
            true
          );
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);

        // Add custom initialization for new version
        this.initializeCustomFeatures();
      }

      /**
       * Initialize custom features specific to the new version
       */
      initializeCustomFeatures() {
        // Add a data attribute to identify this as the new version
        this.setAttribute("data-version", "new");

        // Log initialization (can be removed in production)
        if (window.Shopify && window.Shopify.designMode) {
          console.log("Pickup Availability (New) initialized");
        }
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith("/")) {
          rootUrl = rootUrl + "/";
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        // Dispatch custom event before fetch
        this.dispatchEvent(
          new CustomEvent("pickup-availability-new:before-fetch", {
            detail: { variantId: variantId },
            bubbles: true,
          })
        );

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector(".shopify-section");
            this.renderPreview(sectionInnerHTML);

            // Dispatch custom success event
            this.dispatchEvent(
              new CustomEvent("pickup-availability-new:success", {
                detail: { variantId: variantId },
                bubbles: true,
              })
            );
          })
          .catch((e) => {
            const button = this.querySelector("button");
            if (button)
              button.removeEventListener("click", this.onClickRefreshList);
            this.renderError();

            // Dispatch custom error event
            this.dispatchEvent(
              new CustomEvent("pickup-availability-new:error", {
                detail: { error: e, variantId: variantId },
                bubbles: true,
              })
            );
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute("available");
          this.innerHTML = "";
        }
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector("pickup-availability-drawer-new");
        if (drawer) drawer.remove();
        if (
          !sectionInnerHTML.querySelector("pickup-availability-preview-new")
        ) {
          this.innerHTML = "";
          this.removeAttribute("available");
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector(
          "pickup-availability-preview-new"
        ).outerHTML;
        this.setAttribute("available", "");

        document.body.appendChild(
          sectionInnerHTML.querySelector("pickup-availability-drawer-new")
        );

        const button = this.querySelector("button");
        if (button)
          button.addEventListener("click", (evt) => {
            document
              .querySelector("pickup-availability-drawer-new")
              .show(evt.target);
          });
      }

      renderError() {
        this.innerHTML = this.errorHtml.outerHTML;
        this.querySelector("button").addEventListener(
          "click",
          this.onClickRefreshList
        );
      }
    }
  );
}

if (!customElements.get("pickup-availability-drawer-new")) {
  customElements.define(
    "pickup-availability-drawer-new",
    class PickupAvailabilityDrawerNew extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector("button").addEventListener("click", () => {
          this.hide();
        });

        this.addEventListener("keyup", (event) => {
          if (event.code.toUpperCase() === "ESCAPE") this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest("pickup-availability-drawer-new") &&
          target.id != "ShowPickupAvailabilityDrawer"
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute("open");
        document.body.removeEventListener("click", this.onBodyClick);
        document.body.classList.remove("overflow-hidden");
        removeTrapFocus(this.focusElement);

        // Dispatch custom event
        this.dispatchEvent(
          new CustomEvent("pickup-availability-drawer-new:hide", {
            bubbles: true,
          })
        );
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute("open", "");
        document.body.addEventListener("click", this.onBodyClick);
        document.body.classList.add("overflow-hidden");
        trapFocus(this);

        // Dispatch custom event
        this.dispatchEvent(
          new CustomEvent("pickup-availability-drawer-new:show", {
            bubbles: true,
          })
        );
      }
    }
  );
}
